import React from "react";
import "./LoanCloserReport.css";
import timelineImage from "../assets/h2.png"; // A creative loan/clock/timeline image

const LoanCloserReport = () => {
  return (
    <div className="loan-closer-report-container">
      <div className="loan-closer-report-left-panel">
        <h1 className="loan-closer-report-left-panel-title">Loan Closure Report</h1>
        <p className="loan-closer-report-left-panel-message">
          📊 This page is under development.
        </p>
        <p className="loan-closer-report-left-panel-message">
          Soon, you will be able to monitor all closed loans, track pre-closures, 
          see outstanding balances, and visualize closure timelines.
        </p>
        <p className="loan-closer-report-left-panel-message">
          Powerful features like progress tracking, overdue alerts, and closure statistics are on the way!
        </p>

        <div className="loan-closer-report-left-panel-progress">
          <div className="loan-closer-report-left-panel-progress-bar complete">
            <span>Closed Loans</span>
          </div>
          <div className="loan-closer-report-left-panel-progress-bar pending">
            <span>Pending Closure</span>
          </div>
          <div className="loan-closer-report-left-panel-progress-bar alert">
            <span>Overdue</span>
          </div>
        </div>

        <div className="loan-closer-report-left-panel-flashing-text">
          🔔 LOAN CLOSURE DASHBOARD COMING SOON
        </div>
      </div>

      <div className="loan-closer-report-right-panel">
        <img
          src={timelineImage}
          alt="Loan Timeline"
          className="loan-closer-report-right-panel-image"
        />
      </div>
    </div>
  );
};

export default LoanCloserReport;
